import React, { FC, useState } from "react";
import _ from "lodash";

const Nine11Panel: FC<{ params: DashboardParams }> = ({ params }) => {
  const { screens, setScreens } = params;

  return (
    <div className="main-column ride-dispatch-panel mr-4">
    </div>
  );
};

export default Nine11Panel;
